import { Grid, Tooltip, Typography } from '@material-ui/core';
import { CardPropagandaProps } from './card-propaganda-props';
import { DefaultCard } from '../components/default-card';
import { useDefaultCardStyles } from '../components/default-card/default-card-styles';
import { useThemeQueries } from 'views/theme';
import { EditarIcon } from 'views/components/icons';
import { useStyles } from './card-propaganda-styles'
import { toDateString } from 'utils/to-date';
import { TipoPropagandaLocalMock } from 'data/mocks/tipo-propaganda-local-mock';

export const CardPropaganda = ({
    model,
    onClick,
    onCheck,
}: CardPropagandaProps) => {
    const classes = useDefaultCardStyles();
    const propagandaClasses = useStyles({
        ativo: model.ativo
    });
    const { isMobile, theme } = useThemeQueries();
    const getLocal = TipoPropagandaLocalMock.find(local => local.Key === model.local)

    return (
        <>
            <DefaultCard
                onClick={() => {
                    onClick(model.id);
                }}
            >
                <Tooltip title={model.ativo ? 'Ativo' : 'Inativo'} placement='right'>
                    <div className={propagandaClasses.status} />
                </Tooltip>
                <Grid container className={`${classes.cardContent} ${propagandaClasses.gridContainer}`}>
                    <Grid item xs={6} md={3}>
                        <Typography>Descrição</Typography>
                        <Typography><b>{model.descricao}</b></Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Typography>Data Inicial</Typography>
                        <Typography>{toDateString(model.dtInicial)}</Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Typography>Data Final</Typography>
                        <Typography>{toDateString(model.dtFinal)}</Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Typography>Local</Typography>
                        <Typography>{getLocal?.Value ?? 'Não informado'}</Typography>
                    </Grid>
                </Grid>
                {!isMobile && <Tooltip arrow title='Editar Propaganda'>
                    <div className={classes.cardRightButton} style={{ margin: '7px 0', borderColor: theme.palette.divider }}>
                        <EditarIcon tipo="BUTTON" fill={theme.palette.primary.main} />
                    </div>
                </Tooltip>}
            </DefaultCard>
        </>
    );
};